import { ModelSagres } from "../../model-sagres";

import { ArquivoLicitacao } from "../arquivo-licitacao";
//import { NaturezaAjuste } from "../natureza-ajuste"
//import { TipoTermoAditivo } from "../tipo-termo-aditivo"

export class Licitacao extends ModelSagres {
  //estes campos são da API/banco
  IdLicitacao: number;
  ArquivoLicitacao: ArquivoLicitacao[];
  ContratoLicitacaoPropria: any;
  NrLicitacao: number;
  NrAnoLicitacao: number;
  DeJustificativaDispInex: string;
  DeMotivoAnulCertame: string;
  DeMotivoCancelamentoCertame: string;
  DeMotivoDesercaoCertame: string;
  DeMotivoFracassoCertame: string;
  DeMotivoRevogCertame: string;
  DeNrProcessoAdmin: string;
  DeObjetoLicitacao: string;
  DtAdjudicacao: Date;
  DtAnulacaoCertame: Date;
  DtCancelamentoCertame: Date;
  DtDesercaoCertame: Date;
  DtFracassoCertame: Date;
  DtHomologacao: Date;
  DtPublicacaoEdital: Date;
  DtRevogacaoCertame: Date;
  DtSessaoInaugural: Date;
  DtUltimaAlteracao: Date;
  FlHomologParcial: string;
  FlPagamentoAntecipado: string;
  FlSituacao: string;
  IdCritJulgamento: number;
  IdCritJulgamentoNavigation: any; //terá DeCriterioJulgamento, IdCriterioJulgamento
  IdModalidade: number;
  IdModalidadeNavigation: any; //terá ContratoLicitacaoOutraUg[], ContratoRegistroPreco[], DeModalidade, IdModalidade
  IdNaturezaObjeto: number;
  IdNaturezaObjetoNavigation: any; //DeNaturezaObjeto, IdNaturezaObjeto
  IdNaturezaObra?: number;
  IdNaturezaObraNavigation: any; //DeNaturezaObra, IdNaturezaObra
  IdReferenciaLegal: number;
  IdReferenciaLegalNavigation: any; //DeReferenciaLegal, IdReferenciaLegal
  IdRegimeExecucao: number;
  IdRegimeExecucaoNavigation: any;
  IdUnidGestora: number;
  ItemLicitacao: any[];
  LoteLicitacao: any[];
  NmUsuarioUltimaAlteracao: string;
  NrParticipantes: number;
  NrParticipantesHabilitados: number;
  ParticipanteLicitacao: any[];
  QtDiasPrazoEntrega: number;
  VlEstimadoLicitacao: number;
  VlLicitacao: number;

  //estes campos foram criados para o frontend
  NumeroAnoLicitacao: string;
  IsDispensaInexigibilidade: boolean;
  IsLote: boolean;
  CountItens: number;
  CountLotes: number;

  ArquivoEdital?: any;
  ArquivoAta?: any;
  ArquivoParecer?: any;

  tratarDadosDaAPI(
    isDispensaInex: boolean,
    isLote: boolean,
    countItens: number,
    countLotes: number
  ): void {
    if (this.DtSessaoInaugural) {
      this.DtSessaoInaugural = new Date(this.DtSessaoInaugural);
    }
    if (this.DtHomologacao) {
      this.DtHomologacao = new Date(this.DtHomologacao);
    }
    if (this.DtAdjudicacao) {
      this.DtAdjudicacao = new Date(this.DtAdjudicacao);
    }

    if (this.DtPublicacaoEdital) {
      this.DtPublicacaoEdital = new Date(this.DtPublicacaoEdital);
    }
    if (this.DtAnulacaoCertame) {
      this.DtAnulacaoCertame = new Date(this.DtAnulacaoCertame);
    }
    if (this.DtUltimaAlteracao) {
      this.DtUltimaAlteracao = new Date(this.DtUltimaAlteracao);
    }
    if (this.ArquivoLicitacao) {
      const arqEdital = this.ArquivoLicitacao.find(x => x.IdTipoArquivo === 1)
      const arqAta = this.ArquivoLicitacao.find(x => x.IdTipoArquivo === 2)
      const arqParecer = this.ArquivoLicitacao.find(x => x.IdTipoArquivo === 3)
      if(arqEdital !== undefined) this.ArquivoEdital = Object.assign(new ArquivoLicitacao(), arqEdital);
      if(arqAta !== undefined) this.ArquivoAta = Object.assign(new ArquivoLicitacao(), arqAta);
      if(arqParecer !== undefined) this.ArquivoParecer = Object.assign(new ArquivoLicitacao(), arqParecer);
    }
    if (this.NrLicitacao)
      this.NumeroAnoLicitacao = `${this.NrLicitacao}/${this.NrAnoLicitacao}`;
    if (this.FlHomologParcial) {
      this.FlHomologParcial = this.FlHomologParcial === "S" ? "Sim" : "Não";
    }

    if (isDispensaInex !== undefined)
      this.IsDispensaInexigibilidade = isDispensaInex;
    if (isLote !== undefined) this.IsLote = isLote;
    if (countLotes) this.CountLotes = countLotes;
    if (countItens) this.CountItens = countItens;
  }

  getTipoArquivo(tipo = 'edital') {
    if(tipo === 'edital') {
      if(this.ArquivoEdital instanceof File) return "naosalvo";
      if(this.ArquivoEdital instanceof ArquivoLicitacao) return "salvo";
    }
    else if(tipo === 'ata') {
      if(this.ArquivoAta instanceof File) return "naosalvo";
      if(this.ArquivoAta instanceof ArquivoLicitacao) return "salvo";
    }
    else if(tipo === 'parecer') {
      if(this.ArquivoParecer instanceof File) return "naosalvo";
      if(this.ArquivoParecer instanceof ArquivoLicitacao) return "salvo";
    }
    return null;
  }

  getSituacao() {
    switch (this.FlSituacao) {
      case "LI":
        return "Finalizada";
      /* case "EM":
        return "Em cadastramento"; */
      case "AN":
        return "Anulada";
      default:
        return "Em cadastramento";
    }
  }

  toFormData(): FormData {
    const retorno = super.toFormData();
    if (
      retorno.get("IdNaturezaObra") === "undefined" ||
      retorno.get("IdNaturezaObra") === "0"
    ) {
      retorno.delete("IdNaturezaObra");
    }
    return retorno;
  }
}
